import "./Header.scss"
import profilepicture from "../../Assets/Images/ProfilePicture.png"
import { useEffect, useState } from "react";
import { useSession } from "../../Contexts/Authprovider";
import { useNavigate } from "react-router";
import {ReactComponent as MenuIcon} from "../../Assets/Icons/Menu.svg"
export default function Header(){
  const { ready, isAuthed,user } = useSession();
  const [name, setName] = useState("")
  const [role, setRole] = useState("")
  useEffect(()=>{
    if(ready){
      setName(user.firstname +" " + user.lastname)
      setRole(user.role.rolename)
    }
  },[user, ready])

  const navigate = useNavigate()
  useEffect(()=>{
    if (!isAuthed) {
      return navigate('/login');//redirect juist??
    }
  },[isAuthed,navigate])
  function menuOpen(){
      document.getElementsByClassName('container')[0].classList.add("animateSidebarIn")
      document.getElementsByClassName('container')[0].classList.remove("animateSidebarOut")
  }
  return(
    <div className="HeaderContainer" >
      <div onClick={menuOpen} className="NavBtn2">
        <MenuIcon/>
      </div>
      <div></div>
      <div className="UserContainer">
        <img src={profilepicture} alt="profilepicture"/>
        <p className="username">{name}</p>
        <p className="role">{role}</p>
      </div>
    </div>
  );
}